import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Hotjar from '@hotjar/browser';
import { initClarity } from './utils/clarity';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const siteId = 6543781;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);
initClarity();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
